// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/background@2x.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/images/background-mobile.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeroSection_container__LY6jA {
  position: relative;
  height: 100vh;
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 48px;
}
@media screen and (max-width: 900px) {
  .HeroSection_container__LY6jA {
    justify-content: space-between;
    gap: 0;
  }
}

.HeroSection_background__Warcv {
  position: absolute;
  left: 0;
  bottom: 0;
  align-self: flex-end;
  height: 70vh;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: 1200px;
}
@media screen and (max-height: 768px) {
  .HeroSection_background__Warcv {
    background-position: center top;
  }
}
@media screen and (max-width: 500px) {
  .HeroSection_background__Warcv {
    height: 55vh;
    position: static;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center top;
    background-size: cover;
  }
}

.HeroSection_wrapper__U2hCT {
  position: absolute;
  top: 70px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 1224px;
  margin: 0 auto;
  gap: 70px;
  z-index: 1;
}
@media screen and (min-height: 768px) {
  .HeroSection_wrapper__U2hCT {
    top: 20vh;
  }
}
@media screen and (max-width: 1260px) {
  .HeroSection_wrapper__U2hCT {
    padding: 0 20px;
    grid-template-columns: 3fr 2fr;
  }
}
@media screen and (max-width: 768px) {
  .HeroSection_wrapper__U2hCT {
    padding-top: 20px;
    position: static;
    grid-template-columns: 1fr;
    top: 40px;
    gap: 16px;
  }
}

.HeroSection_titleWrapper__LTrH5 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
}
@media screen and (max-width: 768px) {
  .HeroSection_titleWrapper__LTrH5 {
    gap: 12px;
  }
}

.HeroSection_title__zf3Rg {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  text-align: left;
}
.HeroSection_title__zf3Rg p {
  font-size: 22px;
  font-weight: 300;
}
@media screen and (max-width: 768px) {
  .HeroSection_title__zf3Rg p {
    font-size: 16px;
  }
}
.HeroSection_title__zf3Rg h1 {
  font-size: 72px;
  font-weight: 500;
}
@media screen and (max-width: 768px) {
  .HeroSection_title__zf3Rg h1 {
    font-size: 44px;
  }
}

.HeroSection_info__x7lRF {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 26px;
}
@media screen and (max-width: 600px) {
  .HeroSection_info__x7lRF {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }
}

.HeroSection_infoItem__k8I5C {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 18px;
}
@media screen and (max-width: 500px) {
  .HeroSection_infoItem__k8I5C:nth-child(1) {
    max-width: 175px;
  }
}
@media screen and (max-width: 768px) {
  .HeroSection_infoItem__k8I5C {
    gap: 6px;
  }
}

.HeroSection_label__635Td {
  font-size: 18px;
  font-weight: 300;
}
@media screen and (max-width: 1200px) {
  .HeroSection_label__635Td {
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  .HeroSection_label__635Td {
    font-size: 12px;
  }
}

.HeroSection_value__2PTER {
  font-size: 20px;
  font-weight: 400;
}
@media screen and (max-width: 1200px) {
  .HeroSection_value__2PTER {
    font-size: 16px;
  }
}
@media screen and (max-width: 768px) {
  .HeroSection_value__2PTER {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/HeroSection/HeroSection.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;AACJ;AAAI;EAVJ;IAWQ,8BAAA;IACA,MAAA;EAGN;AACF;;AAAA;EACI,kBAAA;EACA,OAAA;EACA,SAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,yDAAA;EACA,kCAAA;EACA,4BAAA;EACA,uBAAA;AAGJ;AAFI;EAXJ;IAYQ,+BAAA;EAKN;AACF;AAJI;EAdJ;IAeQ,YAAA;IACA,gBAAA;IACA,yDAAA;IACA,+BAAA;IACA,sBAAA;EAON;AACF;;AAJA;EACI,kBAAA;EACA,SAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AAOJ;AANI;EATJ;IAUQ,SAAA;EASN;AACF;AARI;EAZJ;IAaQ,eAAA;IACA,8BAAA;EAWN;AACF;AAVI;EAhBJ;IAiBQ,iBAAA;IACA,gBAAA;IACA,0BAAA;IACA,SAAA;IACA,SAAA;EAaN;AACF;;AAVA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,SAAA;AAaJ;AAZI;EANJ;IAOQ,SAAA;EAeN;AACF;;AAZA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAeJ;AAbI;EACI,eAAA;EACA,gBAAA;AAeR;AAdQ;EAHJ;IAIQ,eAAA;EAiBV;AACF;AAdI;EACI,eAAA;EACA,gBAAA;AAgBR;AAfQ;EAHJ;IAIQ,eAAA;EAkBV;AACF;;AAdA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAiBJ;AAfI;EALJ;IAMQ,aAAA;IACA,eAAA;IACA,SAAA;EAkBN;AACF;;AAfA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;AAkBJ;AAhBQ;EADJ;IAEQ,gBAAA;EAmBV;AACF;AAjBI;EAXJ;IAYQ,QAAA;EAoBN;AACF;;AAjBA;EACI,eAAA;EACA,gBAAA;AAoBJ;AAnBI;EAHJ;IAIQ,eAAA;EAsBN;AACF;AArBI;EANJ;IAOQ,eAAA;EAwBN;AACF;;AArBA;EACI,eAAA;EACA,gBAAA;AAwBJ;AAvBI;EAHJ;IAIQ,eAAA;EA0BN;AACF;AAzBI;EANJ;IAOQ,eAAA;EA4BN;AACF","sourcesContent":[".container {\n    position: relative;\n    height: 100vh;\n    width: 100%;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 48px;\n    @media screen and (max-width: 900px) {\n        justify-content: space-between;\n        gap: 0;\n    }\n}\n\n.background {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    align-self: flex-end;\n    height: 70vh;\n    width: 100%;\n    background-image: url(\"../../../public/images/background@2x.jpg\");\n    background-position: center bottom;\n    background-repeat: no-repeat;\n    background-size: 1200px;\n    @media screen and (max-height: 768px) {\n        background-position: center top;\n    }\n    @media screen and (max-width: 500px) {\n        height: 55vh;\n        position: static;\n        background-image: url(\"../../../public/images/background-mobile.jpg\");\n        background-position: center top;\n        background-size: cover;\n    }\n}\n\n.wrapper {\n    position: absolute;\n    top: 70px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    max-width: 1224px;\n    margin: 0 auto;\n    gap: 70px;\n    z-index: 1;\n    @media screen and (min-height: 768px) {\n        top: 20vh;\n    }\n    @media screen and (max-width: 1260px) {\n        padding: 0 20px;\n        grid-template-columns: 3fr 2fr;\n    }\n    @media screen and (max-width: 768px) {\n        padding-top: 20px;\n        position: static;\n        grid-template-columns: 1fr;\n        top: 40px;\n        gap: 16px;\n    }\n}\n\n.titleWrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 32px;\n    @media screen and (max-width: 768px) {\n        gap: 12px;\n    }\n}\n\n.title {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 8px;\n    text-align: left;\n\n    p {\n        font-size: 22px;\n        font-weight: 300;\n        @media screen and (max-width: 768px) {\n            font-size: 16px;\n        }\n    }\n\n    h1 {\n        font-size: 72px;\n        font-weight: 500;\n        @media screen and (max-width: 768px) {\n            font-size: 44px;\n        }\n    }\n}\n\n.info {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 26px;\n\n    @media screen and (max-width: 600px) {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 16px;\n    }\n}\n\n.infoItem {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n    gap: 18px;\n    &:nth-child(1) {\n        @media screen and (max-width: 500px) {\n            max-width: 175px;\n        }\n    }\n    @media screen and (max-width: 768px) {\n        gap: 6px;\n    }\n}\n\n.label {\n    font-size: 18px;\n    font-weight: 300;\n    @media screen and (max-width: 1200px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 768px) {\n        font-size: 12px;\n    }\n}\n\n.value {\n    font-size: 20px;\n    font-weight: 400;\n    @media screen and (max-width: 1200px) {\n        font-size: 16px;\n    }\n    @media screen and (max-width: 768px) {\n        font-size: 13px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HeroSection_container__LY6jA`,
	"background": `HeroSection_background__Warcv`,
	"wrapper": `HeroSection_wrapper__U2hCT`,
	"titleWrapper": `HeroSection_titleWrapper__LTrH5`,
	"title": `HeroSection_title__zf3Rg`,
	"info": `HeroSection_info__x7lRF`,
	"infoItem": `HeroSection_infoItem__k8I5C`,
	"label": `HeroSection_label__635Td`,
	"value": `HeroSection_value__2PTER`
};
export default ___CSS_LOADER_EXPORT___;
